module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/qd-zhangtiefeng.53d7ea92.jpg";